import React from "react";
import { Box, Container, Typography, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import QUALITY_IMG_TOP from "../../Images/quality-grid-top.jpg";
import QUALITY_IMG_LEFT from "../../Images/quality-grid-left.jpg";
import QUALITY_IMG_RIGHT from "../../Images/quality-grid-right.jpg";
import QUALITY_IMG_BOTTOM from "../../Images/quality-grid-bottom.jpg";

const useStyles = makeStyles((theme) => ({
  qualityTopImg: {
    lineHeight: 0,
  },
  qualityContent: {
    paddingTop: "30px",
    paddingBottom: "30px",
    fontSize: "16px",
    lineHeight: 2,
    textAlign: "justify",
    wordSpacing: 1,
  },
  container: {
    width: "100%",
    paddingRight: "30px",
    paddingLeft: "30px",
  },
  styleCotactButton: {
    color: "#fff",
    border: "1px solid #B20502",
    borderRadius: "4px",
    backgroundColor: "#B20502",
    // padding: '5px 25px',
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: "#B20502" },
    },
  },
  title: {
    marginTop: "20px",
    fontSize: 12,
    fontWeight: "bold",
    color: "#fff",
    textAlign: "center",
    backgroundColor: "#36404b",
    padding: "20px",
    borderBottomRightRadius: "100px",
    borderTopLeftRadius: "100px",
    [theme.breakpoints.up("sm")]: {
      fontSize: 24,
      marginTop: "40px",
    },
    display:'block'
  },
  headText: {
    fontSize:'18px'
  },
  headText1: {
    fontSize:'15px',
    paddingLeft:'9px',
    paddingRight:'9px'
  },
}));
const UniqueQuality = () => {
  const classes = useStyles();
  return (
    <>
      <Box>
        <div className={classes.container}>
          <Container>
          <Box className={classes.qualityContent}>
            <p>
              We are a leading automotive filter manufacturer dedicated to
              providing high-quality filtration solutions for various vehicles.
              With years of expertise in the industry, we take pride in our
              commitment to excellence, innovation, and customer satisfaction.
            </p>
            <p>
              At our manufacturing facility, we leverage state-of-the-art
              technology and advanced production processes to design and produce
              a wide range of automotive filters. Our product line includes air
              filters, oil filters, fuel filters, and cabin air filters, among
              others. We understand the critical role these filters play in
              maintaining the performance, efficiency, and longevity of
              vehicles.
            </p>
            <p>
              Quality is at the heart of everything we do. We adhere to
              stringent quality control measures throughout the manufacturing
              process to ensure that each filter meets the highest industry
              standards. Our team of skilled engineers and technicians work
              tirelessly to develop innovative filtration solutions that
              effectively trap contaminants, improve engine performance, and
              protect the environment.
            </p>
            <p>
              Customer satisfaction is our top priority. We collaborate closely
              with automotive manufacturers, wholesalers, and distributors to
              provide customized filtration solutions that cater to their
              specific needs. We believe in building long-term partnerships
              based on trust, reliability, and mutual success. Our dedicated
              customer support team is always available to assist you with any
              queries or concerns you may have.
            </p>
            <p>
              Sustainability is an integral part of our business philosophy. We
              strive to minimize our environmental impact by implementing
              eco-friendly manufacturing practices and using recyclable
              materials. By promoting cleaner air and improving fuel efficiency,
              our filters contribute to a greener and more sustainable
              automotive industry.
            </p>
            <p>
              We are proud of our track record of delivering exceptional
              filtration products and solutions to our customers worldwide. Our
              commitment to continuous improvement and innovation drives us to
              stay at the forefront of the automotive filtration industry.
            </p>
            </Box>
            </Container>
            <Box display="block" marginBottom={3} sx={{width:'100%'}}>
              <Typography variant="h5" component="h6">
                <Box sx={{}} className={classes.title}>OUR UNIQUE QUALITIES</Box>
              </Typography>
            </Box>
            
            
            {/* <p> */}
              {/* Here are a few reasons to choose GPA over other manufacturers as */}
              {/* your filter supplier. */}
            {/* </p> */}
            {/* <ul>
              <li>
                <b>End to End Capabilities –</b> We can make products to match
                the client’s specifications precisely, at the same time conduct
                full product design, development, testing, and manufacturing.
              </li>
              <li>
                <b>Supply Reliability – </b>With in-house package production and
                suppliers for steel, rubber components, and media within
                striking distance from the plant, we can assure short lead times
                for orders and consistent supply throughout the year.
              </li>
              <li>
                <b>High Volume Capacity – </b>We have one of the largest
                capacities for filter manufacturing in India and the ability to
                expand quickly based on requirements. This helps to serve our
                client’s changing needs and keep up with the demand for
                high-volume parts.
              </li>
              <li>
                <b> Fully Equipped Testing Lab – </b>We continue to invest in
                our testing and R&D capabilities to ensure we provide the
                highest quality parts to our OEM and aftermarket customers.
              </li>
              <li>
                <b>Port Accessibility –</b> With a factory located just 2 hours
                from Port Mundra, shipping to any part of the world will be
                hassle-free.
              </li>
            </ul> */}
          {/* </Box> */}
          {/* <Box >
                    <Button className={classes.styleCotactButton}
                        onClick={() => navigate(routes.CONTACT)}
                        sx={{
                            "&.MuiButtonBase-root": {
                                "&:hover": { backgroundColor: "#B20502" },
                            },
                        }}>
                        Contact Us
                    </Button>
                </Box> */}
                <div style={{backgroundColor: "#E5E8E8",width:'100%',padding:'1%'}}>
          <Grid container>
            <Grid
              container
              xs={12}
              md={4}
              alignItems="center"
              direction="column"
              justifyContent="center"

            >
              <b className={classes.headText}>End to End Capabilities</b>
              <div style={{ textAlign: "justify", paddingRight: "3%" }}>
                <p className={classes.headText1}>
                  We can make products to match the client's specifications
                  precisely, at the same time conduct full product design,
                  development,testing,and manufacturing.
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={4} className={classes.qualityTopImg}>
              <img
                src={QUALITY_IMG_TOP}
                style={{ width: "100%", maxHeight: "350px" }}
                alt="Unique qualities top"
              />
            </Grid>
            <Grid
              container
              xs={12}
              md={4}
              alignItems="center"
              direction="column"
              justifyContent="center"
            >
              <b className={classes.headText}>Supply Reliability</b>
              <div style={{ paddingLeft: "3%", textAlign: "justify" }}>
                <p className={classes.headText1}>
                  With in-house package production and suppliers for steel,
                  rubber components, and media within striking distance from the
                  plant, we can assure short lead times for orders and
                  consistent supply throughout the year.
                </p>
              </div>
            </Grid>
            <Grid xs={12} md={4}>
              <img
                src={QUALITY_IMG_LEFT}
                style={{
                  maxWidth: "100%",
                  maxHeight: "350px",
                  minHeight: "350px",
                }}
                alt="Unique qualities top"
              />
            </Grid>
            <Grid
              container
              xs={12}
              md={4}
              minHeight='350px'
              alignItems="center"
              direction="column"
              justifyContent="center"
            >
              <b className={classes.headText}>High Volume Capacity</b>
              <div
                style={{
                  paddingLeft: "6%",
                  textAlign: "justify",
                  paddingRight: "6%",
                }}
              >
                <p className={classes.headText1}>
                  We have one of the largest capacities for filter manufacturing
                  in India and the ability to expand quickly based on
                  requirements. This helps to serve our client's changing needs
                  and keep up with the demand for high-volume parts.
                </p>
              </div>
            </Grid>
            <Grid xs={12} md={4}>
              <img
                src={QUALITY_IMG_RIGHT}
                style={{ maxWidth: "100%", minHeight: "350px" }}
                alt="Unique qualities top"
              />
            </Grid>
            <Grid
              container
              xs={12}
              md={4}
              alignItems="center"
              direction="column"
              justifyContent="center"
            >
              <b className={classes.headText}> Fully Equipped Testing Lab</b>
              <div style={{ paddingRight: "3%", textAlign: "justify" }}>
                <p className={classes.headText1}>
                  We continue to invest in our testing and R&D capabilities to
                  ensure we provide the highest quality parts to our OEM and
                  aftermarket customers.
                </p>
              </div>
            </Grid>
            <Grid xs={12} md={4}>
              <img
                src={QUALITY_IMG_BOTTOM}
                style={{ maxWidth: "100%", minHeight: "350px",marginTop:'-6px'}}
                alt="Unique qualities top"
              />
            </Grid>
            <Grid
              container
              xs={12}
              md={4}
              alignItems="center"
              direction="column"
              justifyContent="center"
            >
              <b className={classes.headText}>Port Accessibility</b>
              <div style={{ paddingLeft: "3%", textAlign: "justify" }}>
                <p className={classes.headText1}>
                  With a factory located just 2 hours from Port Mundra, shipping
                  to any part of the world will be hassle-free.
                </p>
              </div>
            </Grid>
          </Grid>
          </div>
          </div>
      </Box>
    
    </>
  );
};
export default UniqueQuality;
